import keyBy from 'lodash-es/keyBy';
import { usersActionTypes } from './userActions';
import { IUser } from './usersInterfaces';

export interface IUsersState {
  hash: { [index: string]: IUser };
}

const initialState: IUsersState = {
  hash: {}
};

export function usersReducer(state: IUsersState = initialState, action: usersActionTypes): IUsersState {
  switch (action.type) {
    case 'SET_USERS':
      return {
        ...state,
        hash: {
          ...state.hash,
          ...keyBy<IUser>(action.payload, x => x.sid)
        }
      };
    default:
      return state;
  }
}
